enum PermissionEnum {
    CQS_VISUALIZZA_PRECARICATO = "CQS_VISUALIZZA_PRECARICATO",
    CQS_VISUALIZZA_VOCI_COSTO = "CQS_VISUALIZZA_VOCI_COSTO",
    CQS_Prev_ModCommBanca = "CQS_Prev_ModCommBanca",
    CQS_Prev_VediMontant = "CQS_Prev_VediMontant",
    CQS_Prev_VediIRR = "CQS_Prev_VediIRR",
    CQS_Prev_CommCess = "CQS_Prev_CommCess",
    CQS_WS_CREDITO_NET = "FN_CQS_WS_CREDITO_NET",
}

export default PermissionEnum;
